import { create } from 'zustand'

export const useDynamicManageStore = create((set, get) => ({
    maintenance: '',
    dealJacketId: '',
    vehicleImage: '',
    dealerId: '',
    country: '',
    lang: '',
    brand: '',
    authToken: '',
    pdsStatus: 'readyforcustomer',
    dealerName: '',
    dealerPhoneNumber: '',
    orderId: '',
    rxvt: '',
    onBack: () => {},
    setDynamicManageData: (data) => set(data),
    isStatusPending: () =>
        get().pdsStatus?.toLowerCase() === 'readyforcustomer' || get().pdsStatus?.toLowerCase() === 'pending',
    isStatusAccepted: () =>
        get().pdsStatus?.toLowerCase() === 'completed' || get().pdsStatus?.toLowerCase() === 'accept',
    isStatusRejected: () =>
        get().pdsStatus?.toLowerCase() === 'rejected' || get().pdsStatus?.toLowerCase() === 'reject',
    getPdsStatus: () => {
        if (get().isStatusAccepted()) {
            return 'Accepted'
        } else if (get().isStatusRejected()) {
            return 'Rejected'
        }
    },
    clearMuiStyles: () => {
        document.querySelectorAll('[data-emotion="css-global"]').forEach((e) => e.remove())
    }
}))
